import Vue from 'vue';
import LogoApp from '~/components/_core/ui/logo';

export default Vue.extend({
  components : { LogoApp },
  props      : {
    title    : String,
    subtitle : String,
    goback   : Function,
    showLogo : {
      type    : Boolean,
      default : false
    }
  }
});
